import {
    faBookOpen, faChild, faHandHoldingMedical,
    faHandsHeart, faHomeHeart, faLaughSquint,
    faMusic, faPenNib, faTransporter,
    faUsers, faUserNurse
} from "@fortawesome/pro-solid-svg-icons";


export const faIcons = {
    'fa-hand-heart': faHandsHeart,
    'fa-hands-heart': faHandsHeart,
    'fa-book-open': faBookOpen,
    'fa-laugh-squint':faLaughSquint,
    'fa-music':faMusic,
    'fa-pen-nib' :faPenNib,
    'fa-users' :faUsers,
    'fa-home-heart':faHomeHeart,
    'fa-child':faChild,
    'fa-hand-holding-medical':faHandHoldingMedical,
    'fa-transporter' :faTransporter,
    'fa-user-nurse' :faUserNurse
};
